import { Assessment, Dashboard, LocationCity, MeetingRoom, People, Receipt, Settings } from "@mui/icons-material";
import BusinessCenter from "@mui/icons-material/BusinessCenter";
import { Fade, List, ListItem, SvgIcon } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import { includes } from "lodash";
import { Link } from "react-router-dom";
import "../../styles/components/NavBar.css";
import KMSvg from "../km-logo";
import MoreDrawerLinks from "./MoreDrawerLinks";

const StyledDrawer = styled(MuiDrawer)({
    "& .MuiDrawer-paper": {
        backgroundColor: "transparent",
        overflowY: "auto",
        position: "sticky",
        top: 0,
        width: "220px",
        height: "100vh",
    },
});

const StyledLogoWrapper = styled("div")({
    marginLeft: "15px",
    marginTop: "15px",
    marginBottom: "70px",
});

const StyledIcon = styled(SvgIcon)({
    lineHeight: 0,
    marginRight: "10px",
    width: "20px",
});

const StyledListItem = styled(ListItem, {
    shouldForwardProp: (prop) => prop !== "active",
})(({ active }) => ({
    backgroundColor: active ? "#486f84" : "transparent",
    borderRadius: "3px",
    "&:hover": {
        backgroundColor: active ? "#486f84" : "#233a47",
        borderRadius: "3px",
    },
}));

const NavDrawer = (props) => {
    const { role, user, currentPath, authenticatedUserProfile } = props;

    const fadeInMillis = 600;
    const fadeOutMillis = 200;

    return (
        <StyledDrawer variant="permanent">
            <StyledLogoWrapper>
                <KMSvg />
            </StyledLogoWrapper>
            <List>
                {(authenticatedUserProfile.role === "dataEntry" ||
                    authenticatedUserProfile.role === "dataAdmin" ||
                    authenticatedUserProfile.user === user) &&
                    includes(["broker", "evp", "portlandBrokerAdmin", "arizonaBrokerAdmin"], role) && (
                        <Fade in={true} timeout={{ enter: fadeInMillis, exit: fadeOutMillis }}>
                            <Link className="navOption" to="/dashboard">
                                <StyledListItem active={currentPath === "dashboard"}>
                                    <StyledIcon component={Dashboard} />
                                    Dashboard
                                </StyledListItem>
                            </Link>
                        </Fade>
                    )}
                {includes(
                    [
                        "accounting",
                        "appraiser",
                        "broker",
                        "dataEntry",
                        "dataAdmin",
                        "debtEquity",
                        "evp",
                        "general",
                        "officeManager",
                        "research",
                        "researchAdmin",
                        "portlandBrokerAdmin",
                        "arizonaBrokerAdmin",
                        "propertyManagement",
                        "transition",
                    ],
                    role
                ) && (
                    <Fade in={true} timeout={{ enter: fadeInMillis, exit: fadeOutMillis }}>
                        <Link className="navOption" to="/properties">
                            <StyledListItem active={currentPath === "properties"}>
                                <StyledIcon component={LocationCity} />
                                Properties
                            </StyledListItem>
                        </Link>
                    </Fade>
                )}
                {includes(
                    [
                        "accounting",
                        "appraiser",
                        "broker",
                        "dataAdmin",
                        "dataEntry",
                        "debtEquity",
                        "evp",
                        "general",
                        "officeManager",
                        "research",
                        "researchAdmin",
                        "portlandBrokerAdmin",
                        "propertyManagement",
                        "arizonaBrokerAdmin",
                        "transition",
                    ],
                    role
                ) && (
                    <Fade in={true} timeout={{ enter: fadeInMillis, exit: fadeOutMillis }}>
                        <Link className="navOption" to="/listings">
                            <StyledListItem active={currentPath === "listings"}>
                                <StyledIcon component={MeetingRoom} />
                                Listings
                            </StyledListItem>
                        </Link>
                    </Fade>
                )}
                {includes(
                    [
                        "broker",
                        "dataAdmin",
                        "dataEntry",
                        "debtEquity",
                        "evp",
                        "portlandBrokerAdmin",
                        "arizonaBrokerAdmin",
                    ],
                    role
                ) && (
                    <Fade in={true} timeout={{ enter: fadeInMillis, exit: fadeOutMillis }}>
                        <Link className="navOption" to={"/deals"}>
                            <StyledListItem active={currentPath === "deals"}>
                                <StyledIcon component={Receipt} />
                                Deals
                            </StyledListItem>
                        </Link>
                    </Fade>
                )}
                {includes(
                    [
                        "accounting",
                        "appraiser",
                        "broker",
                        "dataAdmin",
                        "dataEntry",
                        "debtEquity",
                        "evp",
                        "general",
                        "officeManager",
                        "research",
                        "researchAdmin",
                        "propertyManagement",
                        "portlandBrokerAdmin",
                        "transition",
                        "arizonaBrokerAdmin",
                    ],
                    role
                ) && (
                    <Fade in={true} timeout={{ enter: fadeInMillis, exit: fadeOutMillis }}>
                        <Link className="navOption" to="/comps">
                            <StyledListItem active={currentPath === "comps"}>
                                <StyledIcon component={BusinessCenter} />
                                Comps
                            </StyledListItem>
                        </Link>
                    </Fade>
                )}
                {includes(
                    [
                        "accounting",
                        "appraiser",
                        "broker",
                        "dataAdmin",
                        "dataEntry",
                        "debtEquity",
                        "evp",
                        "general",
                        "officeManager",
                        "research",
                        "researchAdmin",
                        "portlandBrokerAdmin",
                        "arizonaBrokerAdmin",
                        "propertyManagement",
                        "transition",
                    ],
                    role
                ) && (
                    <Fade in={true} timeout={{ enter: fadeInMillis, exit: fadeOutMillis }}>
                        <Link className="navOption" to="/contacts">
                            <StyledListItem active={currentPath === "contacts"}>
                                <StyledIcon component={People} />
                                Contacts
                            </StyledListItem>
                        </Link>
                    </Fade>
                )}
                {includes(["dataAdmin", "auditor", "dataEntry", "officeManager"], role) && (
                    <Fade in={true} timeout={{ enter: fadeInMillis, exit: fadeOutMillis }}>
                        <Link className="navOption" to="/audit/">
                            <StyledListItem active={currentPath === "audit"}>
                                <StyledIcon component={Assessment} />
                                Audit
                            </StyledListItem>
                        </Link>
                    </Fade>
                )}
                {includes(["dataAdmin"], role) && (
                    <Fade in={true} timeout={{ enter: fadeInMillis, exit: fadeOutMillis }}>
                        <Link className="navOption" to="/admin/users">
                            <StyledListItem active={currentPath === "admin"}>
                                <StyledIcon component={Settings} />
                                User Admin
                            </StyledListItem>
                        </Link>
                    </Fade>
                )}
                {includes(["dataAdmin", "dataEntry"], role) && (
                    <Fade in={true} timeout={{ enter: fadeInMillis, exit: fadeOutMillis }}>
                        <Link className="navOption" to="/admin/companies">
                            <StyledListItem active={currentPath === "admin"}>
                                <StyledIcon component={Settings} />
                                Company Admin
                            </StyledListItem>
                        </Link>
                    </Fade>
                )}
                {includes(["dataAdmin"], role) && (
                    <Fade in={true} timeout={{ enter: fadeInMillis, exit: fadeOutMillis }}>
                        <Link className="navOption" to="/document-type">
                            <StyledListItem active={currentPath === "document-type"}>
                                <StyledIcon component={Settings} />
                                Document Admin
                            </StyledListItem>
                        </Link>
                    </Fade>
                )}
                {includes(["accounting"], role) && (
                    <Fade in={true} timeout={{ enter: fadeInMillis, exit: fadeOutMillis }}>
                        <Link className="navOption" to={"/vouchers"}>
                            <StyledListItem active={currentPath === "vouchers"}>
                                <StyledIcon component={Receipt} />
                                Vouchers
                            </StyledListItem>
                        </Link>
                    </Fade>
                )}
            </List>
            {!includes(["auditor"], role) && <MoreDrawerLinks />}
        </StyledDrawer>
    );
};

export default NavDrawer;
